import Axios, { AxiosResponse } from 'axios';

import { config } from '../configs/config';

export interface BundleStructure {
  name: string;
  bundle: {
    [bundleVersion: string]: PropertyQuery;
  };
}
export interface BundleValues {
  [bundleName: string]: HatRecord<any>[];
}
export interface PropertyQuery {
  endpoints: EndpointQuery[];
  orderBy?: string;
  ordering?: string;
  limit?: number;
}
export interface EndpointQuery {
  endpoint: string;
  mapping?: {
    [fieldName: string]: string;
  };
  filters?: Filter[];
  links?: EndpointQuery[];
}
export interface Filter {
  field: string;
  transformation?: Transformation;
  operator: Operator;
}
interface Transformation {
  transformation: string;
  part?: string;
}
interface Operator {
  operator: string;
  value?: number | string | boolean;
  lower?: number | string;
  upper?: number | string;
  search?: string;
}
export interface HatRecord<T> {
  endpoint: string;
  recordId: string;
  data: T;
}

export interface HatApplicationContent {
  id: string;
  kind: HatApplicationKind;
  info: HatApplicationInfo;
  developer: HatApplicationDeveloper;
  dependencies?: HatApplicationDependencies;
  permissions: HatApplicationPermissions;
  setup: HatApplicationSetup;
  status: HatApplicationStatus;
}
interface HatApplicationKind {
  kind: string;
  url?: string;
  iosUrl?: string;
  androidUrl?: string;
}
interface HatApplicationInfo {
  version: string;
  name: string;
  headline: string;
  description: HatApplicationDescription;
  hmiDescription?: string;
  dataUsePurpose: string;
  graphics: HatApplicationGraphics;
  published: boolean;
  rating: {
    score: string;
    points?: number;
  };
  supportContact: string;
  termsUrl: string;
  updateNotes?: HatApplicationUpdateNotes;
  primaryColor?: string;
}
export interface HatApplicationDeveloper {
  id: string;
  name: string;
  url: string;
  country: string;
}
interface HatApplicationUpdateNotes {
  header: string;
  notes?: Array<string>;
}
export interface HatApplicationDescription {
  text: string;
}
export interface HatApplicationGraphics {
  banner: HatApplicationGraphicsSize;
  logo: HatApplicationGraphicsSize;
  screenshots: HatApplicationGraphicsSize[];
}
interface HatApplicationGraphicsSize {
  small?: string;
  normal: string;
  large?: string;
  xlarge?: string;
}
export interface HatApplicationPermissions {
  rolesGranted: {
    role: string;
    detail?: string;
  }[];
  dataRequired?: HatApplicationDataRequired;
  dataRetrieved?: BundleStructure;
}
interface HatApplicationDataRequired {
  bundle: BundleStructure;
  startDate: string;
  endDate: string;
  rolling: boolean;
}
export interface HatApplicationSetup {
  url?: string;
  iosUrl?: string;
  androidUrl?: string;
  testingUrl?: string;
  onboarding?: HatApplicationOnboarding[];
  kind: string;
  validRedirectUris: string[];
  dependencies?: string[];
}
interface HatApplicationOnboarding {
  title: string;
  illustration: {
    normal: string;
  };
  description: string;
}
interface HatApplicationDependencies {
  plugs: string[];
  tools: string[];
  contracts: string[];
}
interface HatApplicationStatus {
  compatibility: string;
  expectedStatus?: number;
  dataPreviewEndpoint: string;
  recentDataCheckEndpoint: string;
  staticDataPreviewEndpoint?: string;
  versionReleaseDate: string;
  statusUrl?: string;
  kind: string;
}
export interface HatApplicationPermissions {
  rolesGranted: {
    role: string;
    detail?: string;
  }[];
  dataRequired?: HatApplicationDataRequired;
  dataRetrieved?: BundleStructure;
}
interface HatApplicationDataRequired {
  bundle: BundleStructure;
  startDate: string;
  endDate: string;
  rolling: boolean;
}

export const getApplication = async (applicationId: string): Promise<AxiosResponse<HatApplicationContent>> => {
  const url = `https://dex.dataswift.io/api/v1.1/applications/${applicationId}`;

  return Axios.get<HatApplicationContent>(url);
}


